import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

import { AuditSession, AuthService, CentralizedStockConfiguration, ConfigurationService, messageErrorLogin } from '../../core';
import { CurrentFiltersService } from '../../shared/services/currentFilters/currentFilters.service';
import { MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';

import {  AuthenticationResult } from '@azure/msal-common';

import { environment } from '../../../environments/environment';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { errorType } from '../../core/constants';
const packageJson = require('../../../../package.json');

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  recaptchaResponse: string= "";
  public hidePassword = true;
  public isSubmitting = false;
  public isEnableReCAPTCHA = false;
  public reCAPTCHAKey = "";
  public form: FormGroup;
  public validation_messages = messageErrorLogin;
  public availableCompanies = ['tpsa', 'hpsa', 'spsa'];
  public currentCompany = 0;
  public pattern: RegExp = /^([0-9a-zA-Z'áéíóúñüÁÉÍÓÚÑÜ\s\'\-\_])+$/;
  version = '';
  public isNotProd: boolean = true;

  public showLogginDad: boolean = true;

  _destroying$ = new Subject<void>();

  constructor(
    private router: Router,
    public authService: AuthService,
    formBuilder: FormBuilder,
    private currentFilterService: CurrentFiltersService,
    private configurationService: ConfigurationService,
    private broadcastService: MsalBroadcastService
  ) {
    this.configurationService.getConfigLogin().subscribe((response : any) => {
      if (response && response.data) {
        const config = response.data.find(element => environment.config_enable_login.config_cod === element.configName);
        this.showLogginDad = config.configValue === "true";
        const enablereCAPTCHA = response.data.find(element => environment.config_enable_repactcha.config_reCAPTCHA === element.configName);
        if (enablereCAPTCHA.configValue === "true") { 
          this.reCAPTCHAKey = enablereCAPTCHA.configMetadata.siteKey;
          this.isEnableReCAPTCHA = true;
        }
      }
      this.form = formBuilder.group({
        username: [
          null,
          [
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(20),
            Validators.pattern(this.pattern)
          ]
        ],
        password: [
          '',
          [Validators.required, Validators.minLength(4), Validators.maxLength(20)]
        ]
      });

      if (!this.showLogginDad) {
        this.form.disable();
      }

    });
    this.authService.setUserIp().subscribe(response => { });
    this.version = packageJson.version;

    this.isNotProd = window.location.hostname.includes('-');
  }


  async ngOnInit() {
    this.broadcastService.msalSubject$
      .pipe(
         filter(
            (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS || msg.eventType === EventType.SSO_SILENT_SUCCESS)
       ).subscribe(async (result: EventMessage) => {
         const payload = result.payload as AuthenticationResult;
      });

    this.broadcastService.inProgress$
      .pipe(filter((status: InteractionStatus) => status === InteractionStatus.None)
      ,takeUntil(this._destroying$))
      .subscribe(async () => {
      });

  }

  resolved(captchaResponse: string) {
    this.recaptchaResponse = captchaResponse;
  }

  ngOnDestroy() {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  onSubmit() {
    if (this.isEnableReCAPTCHA && !this.recaptchaResponse) {
      return;
    } else {
      localStorage.setItem(environment.config_enable_repactcha.reCAPTCHA, JSON.stringify(this.recaptchaResponse));
    }
    if (this.showLogginDad) {
      this.loginDad();
    } else {
      this.loginMsal();
    }
  }

  validateStockApi() {
    this.configurationService.getIfTheCompanyHasCentralizedStockEnabled().subscribe((response: CentralizedStockConfiguration) => {
      if (response && response.data
        && response.data[0]
        && response.data[0].configValue
        && (response.data[0].configValue === 'true'
        || response.data[0].configValue === 'false'
      )) {
        localStorage.setItem(environment.useCentralizedStock, response.data[0].configValue);
      }
    });

    this.configurationService.read('CES_ENTITIES_ENABLED').subscribe((response : any) => {
      if (response && response[0] && response[0].configValue) {
         localStorage.setItem(environment.useCentralizedStockEntity, response[0].configValue);

      }
    });
  }

  public loginDad(): void {
    this.isSubmitting = true;
    this.form
      .get('username')
      .setValue(this.form.get('username').value.toUpperCase());
    this.authService
      .login(this.form.value)
      .then((response) => {
        if (response) {
          sessionStorage.removeItem('auth04_username');
          sessionStorage.removeItem('auth04_password_change');
          if (this.authService.getUser()) {
            this.currentFilterService.sessionActivate();
          }
          this.validateStockApi();
          this.router.navigate(['/']);
        }
      })
      .catch((error) => {
        if (error && error.error && error.error.errorType && error.error.errorType === errorType.AUTH04) {
          sessionStorage.setItem('auth04_username', this.form.get('username').value);
          sessionStorage.setItem('auth04_password_change', 'true');
          this.router.navigate(['/cambiar-contraseña']);
        }
      })
      .finally(() => {
        this.isSubmitting = false;
      });
  }

  public loginMsal(): void {
    this.authService.loginMsal().then((response) => {
      if (response) {
        if (this.authService.getUser()) {
          this.currentFilterService.sessionActivate();
        }
        this.validateStockApi();
        this.router.navigate(['/']);
      }
    })
    .finally(() => {
      this.isSubmitting = false;
    });
  }
}
